// Start Imports
import React, { useState, useEffect } from 'react';
import { withTranslation } from "react-i18next";
import API from '../api';
import {
  Box
} from 'grommet';
import Content from '../utils/RenderContent';
import Analytics from '../utils/Analytics';
import RenderHelmet from '../utils/RenderHelmet';
import PageWrap from "../components/PageWrap";
// End Imports

const Press = (props) => {
    //const { t, i18n } = props;
    const { match, t, i18n } = props;
    const [content, setContent] = useState(false);

    // run once on load
    useEffect(() => {
      Analytics.TrackPageView(window.location.pathname)
      loadContent()
    }, []);

    const loadContent = () => {
      API.getPageBySlug(i18n, 'press-and-media').then( (res) => {
        var inlineContent = res.items[0];
        setContent(inlineContent);
      })
      .catch(console.error)
    }

    return (
      <Box id="page">
        <RenderHelmet content={content} match={match} t={t} i18n={i18n} />
        <PageWrap content={content}>
          <Content content={content} match={match} t={t} i18n={i18n} />
        </PageWrap>
      </Box>
    );
}

const PageTranslated = withTranslation("translations")(Press);
export default PageTranslated
